const PaymentMethods = ({
  cardsAvailable,
  oxxoAvailable,
  paypalAvailable,
  coppelpayAvailable,
  applePayAvailable,
  googlePayAvailable,
}) => {
  return (
    <div className="payment-methods">
      {cardsAvailable && (
        <div className="payment-methods-item">
          <div className="cards" />
        </div>
      )}
      {oxxoAvailable && (
        <div className="payment-methods-item">
          <div className="oxxo" />
        </div>
      )}
      {paypalAvailable && (
        <div className="payment-methods-item">
          <div className="paypal" />
        </div>
      )}
      {coppelpayAvailable && (
        <div className="payment-methods-item">
          <div className="coppelpay" />
        </div>
      )}
      {applePayAvailable && (
        <div className="payment-methods-item">
          <div className="apple-pay" />
        </div>
      )}
      {googlePayAvailable && (
        <div className="payment-methods-item">
          <div className="google-pay" />
        </div>
      )}
    </div>
  );
};

export default PaymentMethods;
